const API_BASE_URL =
  process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_API_BASE_URL_DEV
    : process.env.REACT_APP_API_BASE_URL;

export async function fetchWorkflowsAndQueues(env = 'memo') {
  try {
    const res = await fetch(`${API_BASE_URL}/workflows-taskqueues?env=${env}`);
    if (!res.ok) {
      throw new Error('Failed to fetch workflows and task queues');
    }
    const data = await res.json();
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
}
